<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="45"
    style="left: 80px;"
  >
<!--    <v-icon class="mobile-show mr-3 no-outline" size="24">mdi-menu</v-icon>-->
<!--<v-icon class="mobile-show mr-3 no-outline" size="24" @click="returnHome()">mdi-home</v-icon>-->

    <common-breadcrumb class="font-weight-light mobile-hidden"
                       :breadcrumb="_.get($route, 'meta.breadcrumb', [])"/>
    <v-spacer/>
    <div style="color: black; font-size: 11px" class="mr-2">{{BUILD_NUMBER}}</div>
    <v-menu
      bottom
      left
      min-width="400"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
          small
          style="position: relative;"
          @click="noReadTotal = 0"
        >
          <v-icon class="appbar-icon">mdi-bell</v-icon>
          <div v-if="noReadTotal" class="total-notice">{{noReadTotal}}</div>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        flat
        nav
      >
        <ListNoticeTask :updatelist="noReadTotal" />
      </v-list>
    </v-menu>
    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
          small
        >
          <v-icon class="appbar-icon">mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        flat
        nav
      >
        <app-bar-item
          to="/profile"
        >
          <v-list-item-title v-text="'My profile'"/>
        </app-bar-item>
        <v-divider
          class="mb-2 mt-2"
        />
        <a class="d-block btn-logout" @click="logout">
          Logout
        </a>
      </v-list>
    </v-menu>
    <video id="my-video" autoplay style="display: none;" src="https://web1.caresoft.vn/images/320x240.ogg"></video>
    <video id="peer-video" autoplay style="display: none;" src="https://web1.caresoft.vn/images/320x240.ogg"></video>
    <common-voice-call/>
    <common-voice-call-incoming/>
    <common-voice-call-incoming-care-soft/>
    <TriggerTaskPopupCreateAndEditTask/>
    <NoticeTodos :task="taskComming" :showModal="showModal" @closeModal="showModal = false" @openModal="showDetailTodo" />
  </v-app-bar>
</template>

<script>
// Components
import { VHover, VListItem } from 'vuetify/lib';
import { mapState, mapMutations, mapActions } from 'vuex';
import TriggerTaskPopupCreateAndEditTask from '@/components/trigger_task/PopupCreateAndEditTask.vue';
import StudentCareServices from '@/services/StudentCareServices';
import ListNoticeTask from '@/components/trigger_task/ListNoticeTask.vue';
import NoticeTodos from '@/components/trigger_task/NoticeTodos.vue';
import { BUILD_NUMBER } from '../../../build-version';

// Utilities
import TokenService from '../../helpers/token';
import { downloadFile } from '../../helpers/utils';

export default {
  name: 'DashboardCoreAppBar',
  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => h(VListItem, {
              attrs: this.$attrs,
              class: {
                'black--text': !hover,
                'white--text primary elevation-12': hover,
              },
              props: {
                activeClass: '',
                dark: hover,
                link: true,
                ...this.$attrs,
              },
            }, this.$slots.default),
          },
        });
      },
    },
    TriggerTaskPopupCreateAndEditTask,
    ListNoticeTask,
    NoticeTodos,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    BUILD_NUMBER,
    dataAppointment: {},
    showConfirm: false,
    appointmentIds: [],
    profile: [
      { title: 'Profile' },
      { divider: true },
      { title: 'Log out' },
    ],
    totalItem: 0,
    appointments: [],
    hideNotifications: [],
    notificationPosition: [],
    remindContact: [],
    announcements: [],
    marqueeWidth: '60%',
    taskComming: {},
    showModal: false,
    resetList: false,
    noReadTotal: 0,
  }),

  computed: {
    ...mapState(['drawer']),
  },

  created() {
    let socket = false;
    const self = this;
    const user = TokenService.getUser();
    this.getTotalNoReadNotice();
    if (_.isObject(user) && _.size(user)) {
      const username = _.get(user, 'username');
      /* eslint-disable */
      socket = require('socket.io-client')(process.env.VUE_APP_NOTIFICATION_SOCKET_URL, { path: `${process.env.VUE_APP_NOTIFICATION_SOCKET_PATH}/socket.io` });
      /* eslint-enable */
      socket.on('connect', () => {
        console.log('connect', username);
        socket.emit('user_join', { username });
      });
      socket.on(`reminder_task_${user.id}`, (res) => {
        console.log('reminder_task', res);
        this.taskComming = res;
        this.showModal = true;
        setTimeout(() => {
          this.showModal = false;
        }, 7000);
      });
      socket.on(`new_notification_${user.id}`, (res) => {
        console.log('new_notification', res);
        this.getTotalNoReadNotice();
      });
      socket.on('cc_client_export_success', (res) => {
        self.$swal({
          title: 'Đã export thành công!',
          confirmButtonText: 'Download',
        }).then(() => {
          downloadFile(_.get(res, 'filePath', ''), _.get(res, 'fileName', ''));
        });
      });
      socket.on('cc_client_export_blended_tutor_success', (res) => {
        console.log('log', res);
        self.$swal({
          title: 'Đã export thành công!',
          confirmButtonText: 'Download',
        }).then(() => {
          downloadFile(_.get(res, 'filePath', ''), _.get(res, 'fileName', ''));
        });
      });
    }
    Bus.$on('download-excel-filter-data-transaction', (filterForm) => {
      this.getDownloadDataTransaction(filterForm);
    });
    Bus.$on('download-excel-filter-data-blended-transaction', (filterForm) => {
      let levelSubLevel = [];
      if (filterForm && filterForm.programFilter) {
        levelSubLevel = JSON.stringify(filterForm.programFilter.map((e) => e.fakeId));
        // eslint-disable-next-line no-param-reassign
        filterForm.programFilter = filterForm.programFilter.map((e) => e.fakeId);
      }
      this.getDownloadDataTransactionBlended({
        level_sub_level: levelSubLevel,
        ..._.cloneDeep(filterForm),
      });
    });
    Bus.$on('download-excel-filter', (filterForm) => {
      this.getDownloadExcels(filterForm);
    });
    Bus.$on('download-excel-filter-blended', (filterForm) => {
      this.getDownloadExcelsBlended(filterForm);
    });
  },

  methods: {
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
    }),
    ...mapActions('student_care', ['exportData', 'exportTransactionData', 'exportDataSpecialCare', 'exportDataSpecialCareBlended']),
    ...mapActions('blended', ['exportDataBlended']),
    closeModalCall() {
      this.showModal = false;
      this.mobile = '';
      this.appointmentId = 0;
    },
    ...mapMutations('login', ['SET_USER']),
    logout() {
      TokenService.removeRefreshToken();
      TokenService.removeToken();
      TokenService.removeUser();
      TokenService.removePermissions();
      this.SET_USER(null);
      this.$router.push('/login');
    },
    resetCount() {
      this.countNews = 0;
    },
    returnHome() {
      if (this.checkAuthorization('operator_read')) {
        this.$router.push('/tutor/operational-activities');
      } else if (this.checkAuthorization('interviewer_read')) {
        this.$router.push('/tutor/operational-work');
      } else {
        this.$router.push('/tutor-test');
      }
    },
    async getDownloadDataTransactionBlended(filterForm) {
      const loader = this.$loading.show();
      StudentCareServices.exportTransactionDataBlended(filterForm).then(() => {
        this.$swal({
          type: 'success',
          title: 'Export Báo cáo giao dịch thành công',
          text: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!',
        });
        loader.hide();
      }).catch(() => {
        this.$swal({
          type: 'error',
          title: 'Lỗi',
          text: 'Dữ liệu bị lỗi xử lý!',
        });
        loader.hide();
      });
    },
    async getDownloadDataTransaction(filterForm) {
      const loader = this.$loading.show();
      this.exportTransactionData(filterForm).then(() => {
        this.$swal({
          type: 'success',
          title: 'Export Báo cáo giao dịch thành công',
          text: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!',
        });
        loader.hide();
      }).catch(() => {
        this.$swal({
          type: 'error',
          title: 'Lỗi',
          text: 'Dữ liệu bị lỗi xử lý!',
        });
        loader.hide();
      });
    },
    getDownloadExcels(filterForm) {
      const loader = this.$loading.show();
      let result = null;
      if (filterForm.isSpecialCare) {
        result = filterForm.typeScreen === 'blended' ? this.exportDataSpecialCareBlended(filterForm) : this.exportDataSpecialCare(filterForm);
      } else {
        result = this.exportData(filterForm);
      }
      result.then(() => {
        this.$swal({
          type: 'success',
          title: 'Export data thành công',
          text: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!',
        });
        loader.hide();
      }).catch(() => {
        this.$swal({
          type: 'error',
          title: 'Lỗi',
          text: 'Dữ liệu bị lỗi xử lý!',
        });
        loader.hide();
      });
      // this.exportData(filterForm).then(() => {
      //   this.$swal({
      //     type: 'success',
      //     title: 'Export data thành công',
      //     text: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!',
      //   });
      //   loader.hide();
      // }).catch(() => {
      //   this.$swal({
      //     type: 'error',
      //     title: 'Lỗi',
      //     text: 'Dữ liệu bị lỗi xử lý!',
      //   });
      //   loader.hide();
      // });
    },
    getDownloadExcelsBlended(filterForm) {
      const loader = this.$loading.show();
      this.exportDataBlended(filterForm).then(() => {
        this.$swal({
          type: 'success',
          title: 'Export data thành công',
          text: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!',
        });
        loader.hide();
      }).catch(() => {
        this.$swal({
          type: 'error',
          title: 'Lỗi',
          text: 'Dữ liệu bị lỗi xử lý!',
        });
        loader.hide();
      });
    },
    showDetailTodo() {
      const params = { ids: this.taskComming.taskIds.join(',') };
      const routeData = this.$router.resolve({ path: '/student-care/tutor-task', query: { typeCurriculum: 'online', ids: params.ids } });
      window.open(routeData.href, '_blank');
    },
    async getTotalNoReadNotice() {
      const res = await StudentCareServices.getTotalNoReadNocification();
      if (res && res.data) {
        this.noReadTotal = res.data.count;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.notification-has-0 {
  .v-badge__badge {
    display: none;
  }
}

.notification-has-1 {
  .v-badge__badge {
    display: inline-block;
  }
}

.padding-10 {
  padding: 10px;
}

.v-messages__message {
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
}

.appbar-icon {
  font-size: 22px !important;
}

.theme--dark {
  .v-list-item__title {
    .notification {
      .notification-info {
        background-color: #e91e63;

        .notification-item {
          .v-icon {
            color: white;
          }
        }
      }
    }
  }
}

.notification-info {
  background-color: #f1f1f1;
  padding: 5px 10px;

  .notification-item {
    .v-icon {
      color: #a847bf;
    }
  }
}

.notification-header {
  padding: 5px 15px;
  color: #a847bf;
}

.no-outline:focus {
  outline: unset;
}

.hiden-person-result {
  display: none;
}

.announcement-container {
  display: flex;
  background-color: white;
  padding: 0px 10px;
  border-radius: 15px;

  marquee {
    font-size: 16px;
    font-weight: 400;

    .announcement-text {
      color: black;
      text-decoration: unset;
    }

    .announcement-text.has-link {
      cursor: pointer;
    }

    .announcement-text.has-link:hover {
      color: blue;
      text-decoration: underline;
      text-underline-position: below;
    }
  }
}
.total-notice {
  position: absolute;
  border-radius: 70%;
  color: #FFF;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  background-color: #F14E4E;
  padding: 2px 4px;
  top: 5px;
  left: 12px;
}
</style>
